import './vendor/web-awesome/kit-library'
import mrujs from 'mrujs'
import {
  handleJSONRedirectionEvent,
  resetOnAjaxSuccessEvent,
  focusOnAjaxSuccessEvent,
} from './chunks/practical-framework'

document.addEventListener("ajax:complete", handleJSONRedirectionEvent)
document.addEventListener(`ajax:success`, resetOnAjaxSuccessEvent)
document.addEventListener(`ajax:success`, focusOnAjaxSuccessEvent)

mrujs.start()